import { createFileRoute, Outlet } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { Section, SectionTitle } from '@/features/app-shell/section'

export const Route = createFileRoute('/_dashboard/mdr')({
	head: () => ({
		meta: [
			{
				title: 'Executive Reports | BitLyft AIR®',
			},
		],
	}),

	component: RouteComponent,
	errorComponent: RouteErrorComponent,
})

function RouteComponent() {
	return (
		<Section>
			<SectionTitle>Executive Reports</SectionTitle>

			<Outlet />
		</Section>
	)
}
